import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=28cafb07&scoped=true"
import script from "./ActivityItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=28cafb07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cafb07",
  null
  
)

export default component.exports